/**
 * Resolve a capture document row's file-type key for `fileIcons` (pdf, xlsx,
 * g-docs, …). Filename comes from `file_name`, then `media_key`, then the
 * URL path — same precedence the display-name helpers use for uploaded files.
 */

import { fileIcons } from "../../constants/documentIcon";
import { splitFileName } from "./Capture.helpers";
import { captureFileName } from "./captureDisplayName";

const extensionFromPath = (value = "") => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  const withoutQuery = trimmed.split("?")[0].split("#")[0];
  const last = withoutQuery.slice(withoutQuery.lastIndexOf("/") + 1);
  return splitFileName(last).ext.replace(/^\./, "").toLowerCase();
};

const extensionFromUrl = (url) => {
  if (typeof url !== "string" || !url.trim()) return "";
  try {
    return extensionFromPath(new URL(url).pathname);
  } catch {
    return extensionFromPath(url);
  }
};

/** Google / OneDrive URL shapes — mirrors SegmentBuilder EmbedURL. */
export const cloudDocumentType = (url) => {
  if (typeof url !== "string" || !url.trim()) return "";
  const parts = url.split("/");
  if (parts.includes("document")) return "g-docs";
  if (parts.includes("spreadsheets")) return "g-sheets";
  if (parts.includes("presentation")) return "g-slides";
  if (parts.includes("forms")) return "g-forms";
  if (url.includes("drive.google.com")) return "g-drive";
  if (url.includes("sharepoint.com")) return "onedrive";
  return "";
};

/**
 * @param {object} item capture row
 * @returns {string} a `fileIcons` key, or "" when unmapped
 */
export const captureDocumentType = (item) => {
  const fileName =
    (typeof item?.file_name === "string" && item.file_name.trim()) ||
    captureFileName(item) ||
    "";

  let ext = fileName ? splitFileName(fileName).ext.replace(/^\./, "").toLowerCase() : "";
  if (!ext) {
    ext =
      extensionFromUrl(item?.media_url) ||
      extensionFromUrl(item?.source_url);
  }
  if (ext && fileIcons[ext]) return ext;

  const cloud =
    cloudDocumentType(item?.source_url) ||
    cloudDocumentType(item?.media_url);
  if (cloud && fileIcons[cloud]) return cloud;

  return ext || cloud || "";
};
